import { useTranslation } from 'react-i18next'
import setDefaultOptions from 'date-fns/setDefaultOptions'
import { getDateFnsLocaleByLanguage } from 'shared/utils/locale'

const useLocale = () => {
  const { t } = useTranslation('common', { useSuspense: false })
  const language = t('current_language')
  const locale = getDateFnsLocaleByLanguage(language)
  setDefaultOptions({ locale })

  return locale
}

export default useLocale
